module.exports = __webpack_public_path__ + "img/daily_necessities_kitchen.8d3c126a.jpg";